import script from "./CategoriesFilter.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriesFilter.vue?vue&type=script&setup=true&lang=js"

import "./CategoriesFilter.vue?vue&type=style&index=0&id=63612238&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63612238"]])

export default __exports__